import React, { Component } from 'react';
import $ from 'jquery';
import limparHistoricosTranferenciasPassageiros from '../../actions/itinerario/limparHistoricosTranferenciasPassageiros';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerario';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';

export const Cabecalho = () => (
    <div className="lista-eventos titulo">
      <div className="row cabecalho-desktop" style={{ fontWeight: 'bold'}}>
        <div className="col-12 col-sm-12 col-md">Data e Hora</div>        
        <div className="col-12 col-sm-12 col-md">Usuário</div>
        <div className="col-12 col-sm-12 col-md">ID Rota</div>
        <div className="col-12 col-sm-12 col-md">Itinerário Origem</div>
        <div className="col-12 col-sm-12 col-md">Itinerário Destino</div>
        <div className="col-12 col-sm-12 col-md">Poltrona Origem</div>
        <div className="col-12 col-sm-12 col-md">Poltrona Número Origem</div>        
        <div className="col-12 col-sm-12 col-md">Poltrona Destino</div>
        <div className="col-12 col-sm-12 col-md">Poltrona Número Destino</div>
        <div className="col-12 col-sm-12 col-md">Número bilhete </div>
      </div>
    </div>
  );


export class ModalHistoricoTransferenciaPassageiro extends Component {

    fecharModal () {
        $('#modalHistoricoTransferenciaPassageiro')
            .modal('hide');
        $('#modalHistoricoTransferenciaPassageiro')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.limparHistoricosTranferenciasPassageiros();
        this.props.selecionarItinerario(null);
    }


    exibirHistoricos() {
        let htmlEnv = '';
        let htmlRec = '';
        if (this.props.enviados && this.props.enviados.length) {
            htmlEnv = this.props.enviados.map(historico => <div className="lista-eventos" key={`${historico.id}-${historico.data}`}>
                <div className="row conteudo-desktop mb-2">
                    <div className="col-12 col-sm-12 col-md">
                        <Moment
                            format="DD/MM/YYYY HH:mm">{historico.data}</Moment>
                    </div>                    
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{capitalizarTodasPrimeirasLetras(historico.nomeUsuario)}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.idRota}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.idItinerarioOrigem}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.idItinerarioDestino}</p>
                        </div>
                    </div>

                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.idPoltronaOrigem}</p>
                        </div>
                    </div>

                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.numeroPoltronaOrigem}</p>
                        </div>
                    </div>

                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.idPoltronaDestino}</p>
                        </div>
                    </div>

                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.numeroPoltronaDestino}</p>
                        </div>
                    </div>
                    
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.idReserva}</p>
                        </div>
                    </div>
                    
                </div>                
            </div>)
        }

        if (this.props.recebidos && this.props.recebidos.length) {
            htmlRec = this.props.recebidos.map(historico => <div className="lista-eventos" key={`${historico.id}-${historico.data}`}>
                <div className="row conteudo-desktop">
                    <div className="col-12 col-sm-12 col-md">
                        <Moment
                            format="DD/MM/YYYY HH:mm">{historico.data}</Moment>
                    </div>                    
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{capitalizarTodasPrimeirasLetras(historico.nomeUsuario)}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.idRota}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.idItinerarioOrigem}</p>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.idItinerarioDestino}</p>
                        </div>
                    </div>

                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.idPoltronaOrigem}</p>
                        </div>
                    </div>

                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.numeroPoltronaOrigem}</p>
                        </div>
                    </div>

                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.idPoltronaDestino}</p>
                        </div>
                    </div>

                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.numeroPoltronaDestino}</p>
                        </div>
                    </div>

                    <div className="col-12 col-sm-12 col-md">
                        <div id="usuario" className="texto">
                            <p>{historico.idReserva}</p>
                        </div>
                    </div>

                    
                </div>                
            </div>)
        }
        return (
            <div>
                <div>
                    <h2>Enviados</h2>
                    <Cabecalho />
                    {htmlEnv}
                </div>
                <div>
                    <h2>Recebidos</h2>
                    <Cabecalho />
                    {htmlRec}
                </div>                                
            </div>
        )
    }

    render() {
        return (
            <div className="modal fade show" id='modalHistoricoTransferenciaPassageiro' role='dialog'
            aria-labelledby='modalHistoricoTransferenciaPassageiro' aria-hidden='true' data-backdrop='static'>
            <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Históricos Transferências Passageiros - Itinerário {this.props.itinerarioSelecionado.id}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <i className="material-icons" onClick={() => this.fecharModal()}>
                                &#xe5cd;
                            </i>
                        </button>
                    </div>
                    <div className="modal-body">                        
                        {this.exibirHistoricos()}
                    </div>
                </div>
            </div>
        </div>
        )
    }

}


export const mapStateToProps = (state) => {
    return {        
        empresaSelecionada: state.empresaSelecionada,
        itinerarioSelecionado: state.itinerarioSelecionado,
        enviados: state.historicosTransferenciasPassageiros.enviados,
        recebidos: state.historicosTransferenciasPassageiros.recebidos
    }
};

export default connect(mapStateToProps, {
    limparHistoricosTranferenciasPassageiros,
    selecionarItinerario
})(ModalHistoricoTransferenciaPassageiro)